import { useEffect, useState } from 'react'

const useCountdown = (targetDate) => {
  const countDownDate = new Date(targetDate).getTime()

  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime())

  const [startTime, setStartTime] = useState(new Date().getTime())
  const totalTime = new Date(targetDate).getTime() - startTime

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime())
    }, 100)

    return () => clearInterval(interval)
  }, [countDownDate])

  return getReturnValues(countDown, totalTime)
}

const getReturnValues = (countDown, totalTime) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24))
  const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000)
  const miliseconds = countDown
  const perct = (countDown * 100) / totalTime
  return [days, hours, minutes, seconds, miliseconds, perct]
}

export { useCountdown }
